import { makeAutoObservable } from 'mobx'
import { AxiosResponse } from 'axios'

import { AuthApi } from 'api'
import { notification } from 'services'
import { setAuthHeader } from 'services/apiService'
import { TokenResponse } from 'types'

export default class AuthStore {
  token?: string
  initialized: boolean
  loading: boolean

  constructor() {
    this.initialized = false
    this.loading = false

    makeAutoObservable(this)
  }

  *loadToken(initData: string) {
    if (initData) {
      this.initialized = false
      this.loading = true

      try {
        const response: AxiosResponse<TokenResponse> = yield AuthApi.getToken(initData)
        const loadedToken = response.data.data.token

        this.token = loadedToken
        setAuthHeader(loadedToken)

        this.initialized = true
      } catch (ex: any) {
        if (ex?.status === 404) {
          notification.error('Пользователь не найден', {
            autoClose: 4000,
          })
        } else {
          notification.error('Ошибка аутентификации')
        }
        console.log(ex?.message)
      } finally {
        this.loading = false
      }
    }
  }

  *loadTokenInDev(userId: number) {
    if (userId) {
      this.initialized = false
      this.loading = true

      try {
        const response: AxiosResponse<TokenResponse> = yield AuthApi.getTokenInDev(userId)
        const loadedToken = response.data.data.token

        this.token = loadedToken
        setAuthHeader(loadedToken)

        this.initialized = true
      } catch (ex: any) {
        if (ex?.status === 404) {
          notification.error('Пользователь не найден', {
            autoClose: 4000,
          })
        } else {
          notification.error('Ошибка аутентификации')
        }
        console.log(ex?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
